/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { UploadAttachmentRequest } from '../../../../../com/hcl/commerce/typescript/axios';
// @ts-ignore
import { UploadAttachmentResponse } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * UploadAttachmentApi - axios parameter creator
 * @export
 */
export const UploadAttachmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Upload reclaim attachment files against a case ID.
         * @summary Upload reclaim attachments
         * @param {string} storeId The store identifier.
         * @param {UploadAttachmentRequest} uploadAttachmentRequest The request object for uploading attachments.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment: async (storeId: string, uploadAttachmentRequest: UploadAttachmentRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('uploadAttachment', 'storeId', storeId)
            // verify required parameter 'uploadAttachmentRequest' is not null or undefined
            assertParamExists('uploadAttachment', 'uploadAttachmentRequest', uploadAttachmentRequest)
            const localVarPath = `/store/{storeId}/reclaim/uploadAttachment`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadAttachmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UploadAttachmentApi - functional programming interface
 * @export
 */
export const UploadAttachmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UploadAttachmentApiAxiosParamCreator(configuration)
    return {
        /**
         * Upload reclaim attachment files against a case ID.
         * @summary Upload reclaim attachments
         * @param {string} storeId The store identifier.
         * @param {UploadAttachmentRequest} uploadAttachmentRequest The request object for uploading attachments.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadAttachment(storeId: string, uploadAttachmentRequest: UploadAttachmentRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadAttachmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAttachment(storeId, uploadAttachmentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UploadAttachmentApi - factory interface
 * @export
 */
export const UploadAttachmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UploadAttachmentApiFp(configuration)
    return {
        /**
         * Upload reclaim attachment files against a case ID.
         * @summary Upload reclaim attachments
         * @param {string} storeId The store identifier.
         * @param {UploadAttachmentRequest} uploadAttachmentRequest The request object for uploading attachments.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment(storeId: string, uploadAttachmentRequest: UploadAttachmentRequest, options?: any): AxiosPromise<UploadAttachmentResponse> {
            return localVarFp.uploadAttachment(storeId, uploadAttachmentRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UploadAttachmentApi - object-oriented interface
 * @export
 * @class UploadAttachmentApi
 * @extends {BaseAPI}
 */
export class UploadAttachmentApi extends BaseAPI {
    /**
     * Upload reclaim attachment files against a case ID.
     * @summary Upload reclaim attachments
     * @param {string} storeId The store identifier.
     * @param {UploadAttachmentRequest} uploadAttachmentRequest The request object for uploading attachments.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadAttachmentApi
     */
    public uploadAttachment(storeId: string, uploadAttachmentRequest: UploadAttachmentRequest, options?: any) {
        return UploadAttachmentApiFp(this.configuration).uploadAttachment(storeId, uploadAttachmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
